import React, {useEffect, useState, useContext} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';
import FloatingDot from '../components/FloatingDot'; 
import BackGrowndParticles from '../components/BackGrowndParticles'; 
import { CsrfTokenContext } from '../CsrfTokenContext';
import { isTokenExpired, handleLogin } from './utils/AuthenticationHelper';
import './MainPage.css';

const MainPage = () => {
  const navigate = useNavigate();
  const csrfToken = useContext(CsrfTokenContext);

  const [quotes, setQuotes] = useState([]); // Initialize as an empty array
  const [subTitle, setSubTitle] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [randonLogo, setRandonLogo] = useState(0);  

  const handleExploreClick = () => {
    // Redirect to the Simulator page
    navigate('/Simulator');
  };

  const handleAboutClick = () => {
    // Redirect to the Simulator page
    navigate('/About');
  };

  const subTitles = [
    "The future is unknown, but the past helps guide our decisions.",
    "While the future remains uncertain, we can rely on the lessons of the past.",
    "We can't see what's ahead, but we can navigate it with wisdom from the past.",
    "The future is unpredictable, but history shows us the way forward.",
    "We can't control tomorrow, but we can learn from yesterday.",
    "The past can’t predict the future, but it can inspire better choices.",
    "While the future is a mystery, the past offers valuable insights.",
    "We may not know what’s next, but our past decisions light the path.",
    "We can't tell what the future holds, but history prepares us for it.",
    "The future is a blank page, but the past writes the guidebook."
  ];

  useEffect(() => {    
    const randomIndex = Math.floor(Math.random() * subTitles.length);
    setSubTitle(subTitles[randomIndex]);
    
    if(randonLogo===0){
      setRandonLogo(getRandomNumber());
    }

  }, [subTitles, randonLogo]); 


  useEffect(() => {

    const fetchQuotesData = async (quote_limit) => {
      try {
                
        const response = await fetch(`/api/quotes?quote_limit=${quote_limit}`, {
          method: 'GET',
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error);
        }

        const result = await response.json();

        setQuotes(result);
        updSymbolsDaily();        

        // console.log(result[0].quote);
        
      } catch (err) {
        console.error('Error fetching data:', err);        
      }
    };

    const updSymbolsDaily = async () => {
      try { 
        
        // console.log('token for Quote', token);
        // console.log('csrfToken for updSymbolsDaily ',csrfToken);
        
        const response = await fetch(`/api/upd_symbols_daily`, {
          method: 'POST',          
          headers: {            
            'X-CSRFToken': csrfToken,
          } 
        });

        const result = await response.json();

        if (!response.ok) {
          const errorData = await response.json();
          console.log(errorData.error);        
        }
        else{
          console.log(result.message);
          setIsDisabled(false);
        }
    
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };  

    const refreshTokenIfNeeded = async () => {
      console.log('isTokenExpired', isTokenExpired());
      if (isTokenExpired()) {        
        console.log('csrfToken for handleLogin ',csrfToken);
        await handleLogin(csrfToken); // Refresh the token if expired
      }
      if(quotes.length===0){
        fetchQuotesData(15);
      }
    };

    // const token = localStorage.getItem('token');    
    // const user_id = localStorage.getItem('user_id');    
    // const expiresAt = localStorage.getItem('expiresAt');
    // console.log('expiresAt', expiresAt);
    // console.log('token', token);
    // console.log('user_id', user_id);
    // localStorage.removeItem('token');
    // localStorage.removeItem('user_id');
    // localStorage.removeItem('expiresAt');

    if(csrfToken!==''){
      refreshTokenIfNeeded();
    }
   
    
  }, [csrfToken, quotes.length]); 

  const colors = ["#ffff00", "#ff0000", '#0000ff', "#ffc0cb", '#800080', '#00ff00', '#0099ff', '#ff5858', '#878787', '#fff', '#ffb701', '#01ff87', '#f000ff', '#ff00a1', '#ff5500'];

  const titles = [
    "Track Real-Time Market Prices for 200 Cryptocurrency Symbols",
    "Design and Backtest Your Custom Trading Strategies",
    "Experiment with 20 Built-In System Strategies",
    "Get Timely Buy and Sell Signals from Historical Trends",
    "Fine-Tune Strategies with Advanced Backtesting Tools",    
    "Gain Confidence in Your Trading Decisions in Web3 world"
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false
  };

  function getRandomNumber() {
    return Math.floor(Math.random() * 21) + 1;
  }

  return (
    <>
    <div className='about' style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed', /* Change to fixed to keep it at the top */
      top: '0', /* Position it at the top of the page */
      left: '0', /* Align it to the left */
      right: '0', /* Extend it across the width of the page */
      backgroundColor: 'transparent', /* Add a background color to avoid overlap issues */      
      height: '50px',
      zIndex: '3',
      padding: '0 20px' /* Optional: add some padding */
    }}>
      <span style={{ marginRight: '20px' }}></span>
      <span style={{cursor:'pointer'}} onClick={handleAboutClick}>About</span>
    </div>
    <div style={{display:'flex', flexDirection:'column', alignItems:'center', position:'relative', zIndex:'1'}}>
      {randonLogo > 0 &&
        <img width='440px' alt='logo' src={require(`../images/logo/all_bgs/logo${randonLogo}.png`)}/>
      }
    </div>
    <div className="carousel-container">
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
          <BackGrowndParticles />
        </div>
        <div style={{ position: 'relative', zIndex: 2 }}>          
          <Slider {...settings}>
            {titles.map((title, index) => (
              <div key={index} className="carousel-slide">
                <h1>{title}</h1>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <FloatingDot color={colors[0]}  message={quotes.length > 0 ? quotes[0].quote : ''}  author={quotes.length > 0 ?  quotes[0].author : ''} />
      <FloatingDot color={colors[1]}  message={quotes.length > 0 ? quotes[1].quote : ''}  author={quotes.length > 0 ?  quotes[1].author : ''} />
      <FloatingDot color={colors[2]}  message={quotes.length > 0 ? quotes[2].quote : ''}  author={quotes.length > 0 ?  quotes[2].author : ''} />
      <FloatingDot color={colors[3]}  message={quotes.length > 0 ? quotes[3].quote : ''}  author={quotes.length > 0 ?  quotes[3].author : ''} />
      <FloatingDot color={colors[4]}  message={quotes.length > 0 ? quotes[4].quote : ''}  author={quotes.length > 0 ?  quotes[4].author : ''} />
      <FloatingDot color={colors[5]}  message={quotes.length > 0 ? quotes[5].quote : ''}  author={quotes.length > 0 ?  quotes[5].author : ''} />
      <FloatingDot color={colors[6]}  message={quotes.length > 0 ? quotes[6].quote : ''}  author={quotes.length > 0 ?  quotes[6].author : ''} />
      <FloatingDot color={colors[7]}  message={quotes.length > 0 ? quotes[7].quote : ''}  author={quotes.length > 0 ?  quotes[7].author : ''} />
      <FloatingDot color={colors[8]}  message={quotes.length > 0 ? quotes[8].quote : ''}  author={quotes.length > 0 ?  quotes[8].author : ''} />
      <FloatingDot color={colors[9]}  message={quotes.length > 0 ? quotes[9].quote : ''}  author={quotes.length > 0 ?  quotes[9].author : ''} />
      <FloatingDot color={colors[10]} message={quotes.length > 0 ? quotes[10].quote : ''} author={quotes.length > 0 ? quotes[10].author : ''} />
      <FloatingDot color={colors[11]} message={quotes.length > 0 ? quotes[11].quote : ''} author={quotes.length > 0 ? quotes[11].author : ''} />
      <FloatingDot color={colors[12]} message={quotes.length > 0 ? quotes[12].quote : ''} author={quotes.length > 0 ? quotes[12].author : ''} />
      <FloatingDot color={colors[13]} message={quotes.length > 0 ? quotes[13].quote : ''} author={quotes.length > 0 ? quotes[13].author : ''} />
      <FloatingDot color={colors[14]} message={quotes.length > 0 ? quotes[14].quote : ''} author={quotes.length > 0 ? quotes[14].author : ''} />      
    </div>
    <div style={{display:'flex', flexDirection:'column', alignItems:'center', position:'relative', zIndex:'1'}}>
      {randonLogo > 0 &&
        <p className='gradient-text'>{subTitle}</p>   
      }
      <button
        className={`explore-button ${isDisabled ? 'button-disabled' : ''}`} 
        disabled={isDisabled} 
        onClick={handleExploreClick}
      >
        {isDisabled?'Loading...':'Get Started'}
      </button>
    </div>
    <div style={{
      display: 'flex',      
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed', /* Change to fixed to keep it at the top */
      bottom: '0', /* Position it at the top of the page */
      left: '0', /* Align it to the left */
      right: '0', /* Extend it across the width of the page */      
      height: '50px',      
      color:'#131722'      
    }}>
      <span style={{ marginRight: '20px' }}>noletoft</span>      
    </div>
    </>
  );
};

export default MainPage;

  






